import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { isTokenExpired } from './requireAuthComponent';

import { ROLE_VALUES } from '../../constants/customerConstant';

const UserTypeAgnosticAuth = () => {
  const userType = localStorage.getItem('user_type');
  const accessExpiration = localStorage.getItem('access_expiration');
  const refreshExpiration = localStorage.getItem('refresh_expiration');
  const location = useLocation();
  const navigate = useNavigate();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const name = queryParams.get('name');

    const refreshTokenExpired = isTokenExpired(refreshExpiration);
    
    // If both code and region are present in the query params, allow access
    if (code && name) {
      setChecked(true);
      return;
    }
    if (!refreshTokenExpired) {
      setChecked(true);
    } else {
      if (userType === ROLE_VALUES.WHISTLE_BLOWER.toString()) {
        navigate('/login');
      } else if (
        [
          ROLE_VALUES.TENANT_USER,
          ROLE_VALUES.TENANT_ADMIN,
          ROLE_VALUES.EXTERNAL_USER,
          ROLE_VALUES.PARTNER_USER,
          ROLE_VALUES.PARTNER_ADMIN,
        ].includes(Number(userType)) ||
        location.pathname.startsWith('/customer')
      ) {
        navigate('/customer/login');
      } else {
        navigate('/');
      }
    }
  }, [
    location.pathname,
    navigate,
    userType,
    accessExpiration,
    refreshExpiration,
    location.search,
  ]);

  return <>{checked && <Outlet />}</>;
};

export default UserTypeAgnosticAuth;
